import { render, staticRenderFns } from "./TeamMembersPage.vue?vue&type=template&id=699b646a"
import script from "./TeamMembersPage.vue?vue&type=script&lang=js"
export * from "./TeamMembersPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BreadcrumbNavigation: require('/vercel/path0/components/shared/BreadcrumbNavigation.vue').default,ContainerContent: require('/vercel/path0/components/shared/ContainerContent.vue').default,TeamMembers: require('/vercel/path0/components/shared/TeamMembers.vue').default})
